import React from 'react';
import { ActivityIndicator as NativeActivityIndicator, View, ViewStyle, Modal } from 'react-native';
import Theme from 'Theme';
import defaultStyles from './ActivityIndicator.jss';

interface ActivityIndicatorProps {
    style?: ViewStyle;
    size?: number | 'small' | 'large';
    color?: string;
    isOverlay?: boolean;
    opaque?: boolean;
    modal?: boolean;
}

const ActivityIndicator = ({
    style = {},
    size = 'large',
    color = Theme.primaryActiveColor,
    isOverlay = false,
    opaque = false,
    modal = false
}: ActivityIndicatorProps): React.ReactElement => modal ?
        <Modal visible transparent supportedOrientations={['portrait', 'landscape']}>
            <View
                style={[
                    { position: 'absolute', top: 0, left: 0, bottom: 0, right: 0, backgroundColor: 'transparent', justifyContent: 'center', alignItems: 'center' },
                    isOverlay ? defaultStyles.activityIndicator : {},
                    style
                ]}
            >
                <NativeActivityIndicator size={size} color={color} />
            </View>
        </Modal> :
        <View
            style={[
                defaultStyles.holder,
                isOverlay ? defaultStyles.activityIndicator : {},
                opaque ? { opacity: 1 } : {},
                style
            ]}
        >
            <NativeActivityIndicator size={size} color={color} />
        </View>;

export default ActivityIndicator;
